import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { strings } from '../../../../../localization';
import Modal from 'react-modal';
import TagsTreeView from '../../../../TagsTreeView';
import TagsList from '../../../../TagsList';
import TagTypesDropDown from '../../../../TagTypesDropDown';
import { DispatchHelpers, TAG_TYPES, Selectors } from '../../../../../data/tags';
import Permissions from '../../../../../data/permissions';
import ProgressOverlay from '../../../../common/ProgressOverlay';
import ProgressSpinnerSmall from '../../../../common/ProgressSpinnerSmall';
import TagPermissions from '../../../../common/tagsPermissions';
import TagsUtil, {TAG_ACTIONS} from '../../../../common/tagsUtils';



class VehicleTags extends Component {

    state = {
        isRavenTagsModalOpen: false,

        filterRavenTagsByKeyword: '',
        filterRavenTagsByType: [],

        errorMessage: null,
        successMessage: null,
    }

    // There is no setData() method like the ravensPage, usersPage and tagsPage 
    // because in the dashboard, we show all the tags and ravens user has access to, regardless of the role

    openRavenTagsModal = () => {
        this.setState({ 
            isRavenTagsModalOpen: true
        });
    }

    closeRavenTagsModal = () => {
        this.setState({ 
            isRavenTagsModalOpen: false,
            errorMessage: null,
            successMessage: null
         });
    }

    onRavenTagUnassign = (tag) => {
        const {raven} = this.props;

        this.setState({ errorMessage: null, successMessage: null});

        this.props.deleteTagRaven(tag.tagId, raven)
            .then((affectedTags) => { // affectedTags is an array of tags that the raven was unassigned from (The tag directly unassigned and all its descendants)
                
                TagPermissions.removeTagsFromRaven(raven, affectedTags);
                
                this.setState({
                    successMessage: strings.formatString(strings.tags_unassign_success, raven.vehicle.name, tag.name)
                });
            })
            .catch(error => {
                console.error(error);
                this.setState({ errorMessage: TagsUtil.getErrorMessage(error, TAG_ACTIONS.UNASSIGN_RAVEN, tag.name, raven.vehicle.name) });
            });
    }

    onRavenTagsChange = (selectedTagIds) => {
        const {raven} = this.props;
        const ravenTags = raven.tags;

        this.setState({ errorMessage: null, successMessage: null });

        // In each call there is only one change in selectedTags (add or remove)

        // Check if there is a new tag added
        const newTagId = selectedTagIds.find(tagId => !ravenTags.some(rt => rt.tagId === tagId));

        if(newTagId){
            const newTag = this.props.tags.find(t => t.tagId === newTagId);

            this.props.addTagRaven(newTagId, raven)
            .then((affectedTags) => { // affectedTags is an array of tags that the raven was assigned to (The tag directly assigned and all its ancestors)

                this.setState({
                    successMessage: strings.formatString(strings.tags_assign_success, raven.vehicle.name, newTag.name)
                });
            })
            .catch(error => {
                console.error(error);
                
                this.setState({ errorMessage:  TagsUtil.getErrorMessage(error, TAG_ACTIONS.ASSIGN_RAVEN, newTag.name, raven.vehicle.name) });
            });

            return;
        }

        // Check if there is a tag removed
        const deletedTag = ravenTags.find(rt => !selectedTagIds.includes(rt.tagId));

        if(deletedTag){
            
            this.props.deleteTagRaven(deletedTag.tagId, raven)
            .then((affectedTags) => { // affectedTags is an array of tags that the raven was unassigned from (The tag directly unassigned and all its descendants)

                this.setState({
                    successMessage: strings.formatString(strings.tags_unassign_success, raven.vehicle.name, deletedTag.name)
                 });
            })
            .catch(error => {
                console.error(error);
                this.setState({ errorMessage:  TagsUtil.getErrorMessage(error, TAG_ACTIONS.UNASSIGN_RAVEN, deletedTag.name, raven.vehicle.name) });
            });
        }

    }

    renderTags = () => {
        const ravenTags = this.props.raven.tags;
        const showTagsSection = ravenTags && ravenTags.length > 0;
        
        if(!showTagsSection){
            return null;
        }

        return (
                <div className='vehicle-tags'>
                    <TagsList tags={ravenTags} linear={true} showMore={false} compact />
                    <div>
                        <i className="material-icons show-all-tags" title={strings.tags_show_all_tags} onClick={this.openRavenTagsModal}>more_horiz</i>
                    </div>
                </div>
            );
    }

    renderTagsModal = () => {
        const {raven} = this.props;

        const ravenTagsFiltered = this.filterRavenTags();

        const ravenTagsIds = raven.tags.map(tag => tag.tagId);

        const includeSystemType = raven.tags.some(tag => tag.type === TAG_TYPES.SYSTEM);

        return (
            <>
            <Modal 
                isOpen={this.state.isRavenTagsModalOpen}
                className={`tags-action-modal react-modal-content react-modal ${this.props.readOnly ? 'assigned-tags-only' : ''}`}
                overlayClassName="react-modal-overlay"
                shouldCloseOnOverlayClick={false}
                onRequestClose={this.closeRavenTagsModal}
            >
                <div className="container-fluid">
                    <div className='row header'>
                        <div className='col-12'>
                            <h2>{strings.raven_name} <span className="assigned-to">{this.props.raven.vehicle.name}</span></h2>
                        </div>
                        <div className='col-12'>
                            {this.state.successMessage &&  <div className='success-message'>{this.state.successMessage}</div>}
                            <ul className='errors'>
                                {this.state.errorMessage &&  <li className='error-message'>{this.state.errorMessage}</li>}
                            </ul>
                        </div>
                    </div>
                    <div className='row'>
                        {/* All the available tags. Show only if user is not just guest  */}
                        {!this.props.readOnly &&
                            <div className='col-6 col-xl-5'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <h3>{strings.tags_available_tags}</h3>
                                    </div>
                                </div>
                                <div className='row'>
                                    {/* Tags Treeview*/ }
                                    <div className='col-12'>
                                        <TagsTreeView 
                                            tags={this.props.tags}
                                            resource={this.props.raven.vehicle.name}
                                            expandedTagsIds={ravenTagsIds} 
                                            selectedTagsIds={ravenTagsIds} 
                                            onChange={this.onRavenTagsChange}
                                            multipleSelection
                                            showConfrimOnDeselect
                                            disableGuestTags
                                            disableRootTag
                                            showTooltips
                                            compact
                                        />
                                    </div>
                                </div>
                            </div>
                        }

                        {/* Tags assigned to current raven */}
                        <div className={this.props.readOnly ? 'col-12' : 'col-6 col-xl-6 offset-xl-1'}>
                            <div className="row header">
                                <div className='col-12'>
                                    <h3>{strings.tags_assigned_tags}</h3>
                                </div>
                            </div>
                            {/* Filter */}
                            <div className='row'>
                                <div className={this.props.readOnly ? 'col-6 filters' : 'col-12 filters'}>
                                    <input type="text" placeholder={strings.placeholder_filter} value={this.state.filterRavenTagsByKeyword} onChange={(e) => this.setState({filterRavenTagsByKeyword: e.target.value})} />
                                    <TagTypesDropDown 
                                        includeSystemType={includeSystemType} 
                                        selectedItems={this.state.filterRavenTagsByType}
                                        onChange={(selectedItems) => this.setState({filterRavenTagsByType: selectedItems})}
                                        multipleSelection={true}
                                    />
                                </div>
                            </div>
                             {/* list of raven tags */}
                             <div className='row'>
                                <TagsList 
                                    tags={ravenTagsFiltered} 
                                    className={'col-12'} 
                                    resource={this.props.raven.vehicle.name}                                    
                                    onUnassign={this.onRavenTagUnassign} 
                                    disableGuestTags
                                    disableRootTag
                                    canUnassign 
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 actions">
                            <button className="btn btn-outline-blue" onClick={this.closeRavenTagsModal}><i className="material-icons">close</i>{strings.app_close}</button>
                        </div>
                    </div>
                </div>
                {this.props.tagRavensChangesPending && <ProgressOverlay />}
            </Modal>
            </>
        );
    }
    
    filterRavenTags = () => {
        let list = this.props.raven.tags || [];

        if(this.state.filterRavenTagsByKeyword){
            list = list.filter(tag => tag.name.toLowerCase().includes(this.state.filterRavenTagsByKeyword.toLowerCase()));
        }

        if(this.state.filterRavenTagsByType.length > 0){
            list = list.filter(tag => this.state.filterRavenTagsByType.includes(tag.type));
        }

        return list;
    }

    render() {
        // There is no error, no loading and no loaded tags. So, can conclude Tags are not enabled.
        const tagsNotEnabled = !this.props.tagsLoaded && !this.props.tagsLoading && !this.props.tagsError;

        if(tagsNotEnabled){
            console.log('VehicleTags: Tags are not enabled');
            return null;
        }

        let content = null;

        if(this.props.tagsError){
            content = <div className='error-message'><i className="material-icons">error_outline</i>{strings.tags_loading_tags_error}</div>;
        }
        else if(this.props.tagsLoading){
            content = <div className='loading-tags'><ProgressSpinnerSmall/><div>{strings.tags_loading_tags}</div></div>;
        }
        else {
            content = this.renderTags();
        }
        
        return (
            <div className="row section-wrapper">
                <div className="col-12 section-body">
                    <div className='row'>
                        <div className='vehicle-tags'>
                            {content}
                        </div>
                    </div>
                    
                </div>
                {this.state.isRavenTagsModalOpen && this.renderTagsModal()}
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        tagRavensChangesPending: Selectors.tagPropChangePending(state), // A tag's prop is being updated (tag.name, tag.style, tag.ravens, ...)
        readOnly: !Permissions.selectors.can(state, 'tags', 'write'), // user can only read tags, not assign/unassign
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        deleteTagRaven: (tagId, raven) => dispatch(DispatchHelpers.deleteTagRaven(tagId, raven)),
        addTagRaven: (tagId, raven) => dispatch(DispatchHelpers.addTagRaven(tagId, raven)),
    }
};

export { VehicleTags as UnconnectedVehicleTags }; // added for unit tests
export default connect(mapStateToProps, mapDispatchToProps)(VehicleTags);